import { useConfigContext } from '@fe-core';
import { getSessionStates } from '../utils/getSessionStates';
import { TSelfregSessionDetails } from '@api/io/selfreg.io';

export const useSelfregSessionStates = (
  sessionDetails: TSelfregSessionDetails,
) => {
  const { config } = useConfigContext();

  return getSessionStates(sessionDetails, config.webfeatures);
};
